import React, { useMemo } from "react"
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import { Accordion } from 'react-bootstrap'
import { useUrlFriendlyToParameters, useGetURL } from 'helpers/urlFriendly';
import Label, { useLabels } from "components/general/Label"
import { Link } from "react-router-dom"
import Noc from "components/presentation/Noc"

const getConfiguration = (breakPoint, isAlphabeticalSort, params) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };
  configuration.sortBy = [{ id: "Noc", desc: false }];
  configuration.columns = isMobile ? TableColumnsSM(isAlphabeticalSort, params) : TableColumns(isAlphabeticalSort, params)
  return configuration;
};

const EntriesNocsTable = ({ data, footerData }) => {
  let params = useUrlFriendlyToParameters();
  const getURL = useGetURL();
  const fLabel = useLabels();
  params.getURL = getURL;
  let isAlphabeticalSort = !(data?.some(disc => disc?.organisation?.longDescription && disc?.organisation?.longDescription !== 0));
  const { breakPoint } = useViewport();
  const config = useMemo(() => getConfiguration(breakPoint, isAlphabeticalSort, params), [breakPoint, isAlphabeticalSort, params]);

  return (
    <MirsTable
      className="table-schedule"
      containerColumnClassName="medals-container-column"
      data={data}
      columns={config.columns}
      keyRow='participant-code'
      initialSortBy={config.sortBy}
      id={`mirs-table-entries`}
      showPagination={true}
      // pageSizeCustom={10}
      footerData={footerData}
      summaryDesc={fLabel({ data: 'SummaryEntriesPage' })}
    />
  )
}

function TableColumns(isAlphabeticalSort, params) {
  return (
    [
      ColumnNocRowSpan({ isAlphabeticalSort: isAlphabeticalSort }),
      ColumnGender({ params: params })
    ]
  )
}

function TableColumnsSM(isAlphabeticalSort, params) {
  return (
    [
      ColumnNocRowSpan({ isAlphabeticalSort: isAlphabeticalSort }),
      ColumnGender({ params: params })
    ]
  )
}

function ColumnNocRowSpan({ isAlphabeticalSort = true }) {
  return {
    Header: "NOCRowSpan",
    enableRowSpan: true,
    relatedId: 'Noc',
    headerClassName: "text-center text-nowrap align-middle",
    id: 'HeaderNOC',
    columns: [
      ColumnNoc({ isAlphabeticalSort: isAlphabeticalSort })
    ]
  }
}

function ColumnNoc({ isAlphabeticalSort = true }) {
  return (
    {
      Header: <Label data={"HeaderNOC"} />,
      accessor: isAlphabeticalSort ? 'organisation.longDescription' : 'organisation.longDescriptionOrder',
      className: "text-center",
      headerClassName: "text-center text-nowrap",
      disableSortBy: false,
      remove: true,
      id: 'Noc',
      Cell: (props) => {
        const row = props.cell.row.original;
        return (<Noc {...row?.organisation} longDescription={row?.organisation?.description || row?.organisation?.longDescription} showImage={true} showLongDesc={true} hasLink={true} urlLink={"entriesbynoc"} showImgAlt={false} />);
      }
    }
  )
}

function ColumnGender({ params }) {
  return {
    id: 'Gender',
    Header: <Label data={"HeaderGender"} />,
    headerClassName: "text-center",
    columns: [ColumnCount({ gender: 'M' }), ColumnCount({ gender: 'F' }), ColumnCount({ gender: 'T', params: params })]
  }
}

function ColumnCount({ gender, params, getURL }) {
  let _params = { ...params }


  let labelText = '';
  let accessorVar = '';
  if (gender === "M") {
    labelText = 'HeaderMen';
    accessorVar = 'gender.M'
  } else if (gender === "F") {
    labelText = 'HeaderWomen';
    accessorVar = 'gender.F'
  } else if (gender === "T") {
    labelText = 'HeaderTotal';
    accessorVar = 'gender.T'
  }

  return (
    {
      Header: <Label data={labelText} />,
      accessor: accessorVar,
      className: "text-center",
      headerClassName: "text-center w-10 text-nowrap",
      disableSortBy: false,
      id: gender,
      Cell: (props) => {
        const row = props.cell.row.original;
        if (labelText === 'HeaderTotal') {
          _params["mirs_noc"] = row?.organisation?.code;
          let url = _params.getURL(_params, "nocentriesbyevent")

          return <Link to={url} style={{ textDecoration: 'none' }}>{row?.gender?.[gender]}</Link>
        }

        return row?.gender?.[gender];
      }
    }
  )
}

export default EntriesNocsTable;

